const DEFAULT_ERROR_MESSAGE = "通信エラーが発生しました。時間をおいて再度お試しください。";

const getCsrfToken = () => {
  const meta = document.querySelector("meta[name='csrf-token']");
  return meta ? meta.getAttribute("content") : null;
};

const getLoading = (container) => container.querySelector("[data-quick-satisfaction-survey-loading]");
const getError = (container) => container.querySelector("[data-quick-satisfaction-survey-error]");
const getRadios = (form) => form.querySelectorAll("input[type='radio']");

const toggleLoading = (container, visible) => {
  const loading = getLoading(container);
  if (!loading) return;
  loading.classList.toggle("hidden", !visible);
  loading.setAttribute("aria-busy", visible ? "true" : "false");
};
const toggleInputs = (form, disabled) => getRadios(form).forEach((radio) => (radio.disabled = disabled));
const clearError = (container) => {
  const error = getError(container);
  if (!error) return;
  error.textContent = "";
  error.classList.add("hidden");
};
const showError = (container, message) => {
  const error = getError(container);
  if (!error) return;
  error.textContent = message || DEFAULT_ERROR_MESSAGE;
  error.classList.remove("hidden");
};
const setSelection = (form, value) => getRadios(form).forEach((radio) => (radio.checked = radio.value === value));
const clearSelection = (form) => getRadios(form).forEach((radio) => (radio.checked = false));
const revertSelection = (form, currentValue) => (currentValue ? setSelection(form, currentValue) : clearSelection(form));

const handleChange = async (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;
  if (target.type !== "radio") return;

  const form = target.closest("form[data-quick-satisfaction-survey-form]");
  if (!form) return;

  const container = form.closest("[data-quick-satisfaction-survey-container]");
  if (!container) return;

  if (container.dataset.submitting === "true") return;

  const currentValue = container.dataset.currentValue || "";
  const pendingValue = target.value;
  container.dataset.pendingValue = pendingValue;

  revertSelection(form, currentValue);

  container.dataset.submitting = "true";
  clearError(container);
  toggleLoading(container, true);
  toggleInputs(form, true);

  await new Promise(requestAnimationFrame);

  const formData = new FormData(form);
  formData.set("anytime_consultation_answer[quick_satisfaction_survey]", pendingValue);

  const csrfToken = getCsrfToken();

  try {
    const response = await fetch(form.action, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {})
      },
      body: formData,
      credentials: "same-origin"
    });

    if (!response.ok) {
      let errorMessage = DEFAULT_ERROR_MESSAGE;
      try {
        const data = await response.json();
        if (data && data.error) errorMessage = data.error;
      } catch {
        // ignore json parse error
      }
      showError(container, errorMessage);
      revertSelection(form, currentValue);
      return;
    }

    setSelection(form, pendingValue);
    container.dataset.currentValue = pendingValue;
    container.dataset.pendingValue = "";
  } catch (error) {
    console.error("Quick satisfaction survey submission failed:", error);
    showError(container, DEFAULT_ERROR_MESSAGE);
    revertSelection(form, currentValue);
  } finally {
    toggleLoading(container, false);
    toggleInputs(form, false);
    container.dataset.submitting = "false";
  }
};

if (!window.__quickSatisfactionSurveyInitialized) {
  window.__quickSatisfactionSurveyInitialized = true;
  document.addEventListener("change", handleChange);
}
